<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="memberCertificateForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                memberCertificateForm: () => import('../forms/MemberCertificateForm'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "memberId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'memberCertificates',
                editPageName: 'memberCertificate',
                apiMethod: 'MemberCertificates',
                claimName: 'MemberCertificates',
                formTitle: 'Member Certificate',
                excelTitle: 'Member Certificates',
                hasEditPage: false,
            }
        },
    };
</script>
